import { render } from "./Shippingservices.vue?vue&type=template&id=87a40c44&scoped=true"
import script from "./Shippingservices.vue?vue&type=script&lang=js"
export * from "./Shippingservices.vue?vue&type=script&lang=js"

import "./Shippingservices.vue?vue&type=style&index=0&id=87a40c44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87a40c44"]])

export default __exports__